import colorsOptions from '../../fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions
} from '../../fundamentals/text-styles/constants'
import { iconSizes } from '../icons/icons-sizes'
import {
  PrimaryButton,
  PrimaryDestructiveButton,
  LinkButton,
  SecondaryHollowButton,
  SecondaryWhiteFillButton,
  SecondaryInvertedButton,
  SecondaryDestructiveHollowButton,
  SecondaryDestructiveWhiteFillButton,
  SecondaryDestructiveInvertedButton,
  TertiaryHollowButton,
  TertiaryWhiteFillButton,
  GhostButton,
  GhostInvertedButton,
  GhostDestructiveButton,
  GhostDestructiveInvertedButton,
  ImageOverlayButton,
  FloatingButton,
  SideImageOverlay
} from './styled-components'

const buttonSizeOptions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
}

const buttonLinkSizeOptions = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge'
}

const buttonTypeOptions = {
  STANDARD: 'standard',
  'ICON-ONLY': 'icon-only'
}

const buttonVariantOptions = {
  PRIMARY: 'primary',
  'PRIMARY-DESTRUCTIVE': 'primary-destructive',

  'SECONDARY-HOLLOW': 'secondary-hollow',
  'SECONDARY-WHITE-FILL': 'secondary-white-fill',
  'SECONDARY-INVERTED': 'secondary-inverted',
  'SECONDARY-DESTRUCTIVE-HOLLOW': 'secondary-destructive-hollow',
  'SECONDARY-DESTRUCTIVE-WHITE-FILL': 'secondary-destructive-white-fill',
  'SECONDARY-DESTRUCTIVE-INVERTED': 'secondary-destructive-inverted',

  'TERTIARY-HOLLOW': 'tertiary-hollow',
  'TERTIARY-WHITE-FILL': 'tertiary-white-fill',

  GHOST: 'ghost',
  'GHOST-INVERTED': 'ghost-inverted',
  'GHOST-DESTRUCTIVE': 'ghost-destructive',
  'GHOST-DESTRUCTIVE-INVERTED': 'ghost-destructive-inverted',

  LINK: 'link',
  'IMAGE-OVERLAY': 'image-overlay',
  'SIDE-IMAGE-OVERLAY': 'side-image-overlay',
  'FLOATING-BUTTON': 'floating-button'
}

const buttonVariantComponentOptions = {
  [buttonVariantOptions.PRIMARY]: PrimaryButton,
  [buttonVariantOptions['PRIMARY-DESTRUCTIVE']]: PrimaryDestructiveButton,

  [buttonVariantOptions['SECONDARY-HOLLOW']]: SecondaryHollowButton,
  [buttonVariantOptions['SECONDARY-WHITE-FILL']]: SecondaryWhiteFillButton,
  [buttonVariantOptions['SECONDARY-INVERTED']]: SecondaryInvertedButton,
  [buttonVariantOptions['SECONDARY-DESTRUCTIVE-HOLLOW']]:
    SecondaryDestructiveHollowButton,
  [buttonVariantOptions['SECONDARY-DESTRUCTIVE-WHITE-FILL']]:
    SecondaryDestructiveWhiteFillButton,
  [buttonVariantOptions['SECONDARY-DESTRUCTIVE-INVERTED']]:
    SecondaryDestructiveInvertedButton,

  [buttonVariantOptions['TERTIARY-HOLLOW']]: TertiaryHollowButton,
  [buttonVariantOptions['TERTIARY-WHITE-FILL']]: TertiaryWhiteFillButton,

  [buttonVariantOptions.GHOST]: GhostButton,
  [buttonVariantOptions['GHOST-INVERTED']]: GhostInvertedButton,
  [buttonVariantOptions['GHOST-DESTRUCTIVE']]: GhostDestructiveButton,
  [buttonVariantOptions['GHOST-DESTRUCTIVE-INVERTED']]:
    GhostDestructiveInvertedButton,

  [buttonVariantOptions.LINK]: LinkButton,
  [buttonVariantOptions['IMAGE-OVERLAY']]: ImageOverlayButton,
  [buttonVariantOptions['FLOATING-BUTTON']]: FloatingButton,
  [buttonVariantOptions['SIDE-IMAGE-OVERLAY']]: SideImageOverlay
}

const buttonSizeStyleOptions = {
  [buttonSizeOptions.SMALL]: {
    iconSize: iconSizes['icon-s'],
    height: '32px',
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']],
    borderWidth: '1px',
    padding: '0 1rem'
  },
  [buttonSizeOptions.MEDIUM]: {
    iconSize: iconSizes['icon-m'],
    height: '40px',
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']],
    borderWidth: '1.25px',
    padding: '0 2rem'
  },
  [buttonSizeOptions.LARGE]: {
    iconSize: iconSizes['icon-l'],
    height: '48px',
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']],
    borderWidth: '1.5px',
    padding: '0 2.5rem'
  }
}

const buttonLinkStyleOptions = {
  [buttonLinkSizeOptions.SMALL]: {
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-S']]
  },
  [buttonLinkSizeOptions.MEDIUM]: {
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]
  },
  [buttonLinkSizeOptions.LARGE]: {
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]
  },
  [buttonLinkSizeOptions.XLARGE]: {
    ...textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]
  }
}

const buttonSideOptions = {
  LEFT: 'left',
  RIGHT: 'right'
}

const buttonSideOptionsStyle = {
  [buttonSideOptions.LEFT]: {
    borderRadius: '150px 0px 0px 150px',
    padding: '0.5rem 0.25rem 0.5rem 0.5rem',
    border: `2px solid ${colorsOptions.docuToolsOrange.orange}`,
    borderRight: 'none'
  },
  [buttonSideOptions.RIGHT]: {
    borderRadius: '0px 150px 150px 0px',
    padding: '0.5rem 0.5rem 0.5rem 0.25rem',
    border: `2px solid ${colorsOptions.docuToolsOrange.orange}`,
    borderLeft: 'none'
  }
}

export {
  buttonSizeOptions,
  buttonTypeOptions,
  buttonVariantOptions,
  buttonVariantComponentOptions,
  buttonSizeStyleOptions,
  buttonLinkSizeOptions,
  buttonLinkStyleOptions,
  buttonSideOptions,
  buttonSideOptionsStyle
}
